/* applicationSidebar Module */

var applicationSidebar = angular.module('applicationSidebar');
applicationSidebar.classy.controller({
    name: 'ApplicationSideBarController',
    inject: ['$scope', 'ApplicationService','ApplicationSideBarService','$sce',
            '$rootScope', '$location', 'EditApplicantsModalService', 'AppModelService',
            'BinFactory', 'SchoolSubcategoriesModelService', 'TabsService',
            'MainContentService', 'AlertService', '$timeout', 'PermissionModelService', 'authServiceFactory', 'SliderFactory',
            'SchoolModelService', 'DetermineAwardService', 'DateService', 'GradeSetupModelService', 'SliderService', 'CheckListService'],
    init: function()
    {
        if (!this.$.ApplicationService.getLoadingApplication())
        {

            //Both
            this.$.sce = this.$sce;
            this.$.authServiceFactory = this.authServiceFactory;
            this.$.ApplicationService = this.ApplicationService;
            this.$.ApplicationSideBarService = this.ApplicationSideBarService;
            this.$.EditApplicantsModalService = this.EditApplicantsModalService;
            this.$.MainContentService = this.MainContentService;
            this.$.DetermineAwardService = this.DetermineAwardService;
            this.$.DateService = this.DateService;
            this.$.GradeSetupModelService = this.GradeSetupModelService;
            this.$.CheckListService = this.CheckListService;

            this.$.schoolinfo = this.SchoolModelService.get()[0];
            if (this.ApplicationService.getAwardData()!==undefined)
                this.$.applicants = this.ApplicationService.getAwardData().applicants;
            this.$.isArchive = this.BinFactory.isArchive();
            var parent = this; 
            if (this.$.applicants!==undefined) {
                for (var i = 0; i < this.$.applicants.length; i++) {
                    angular.forEach(this.$.applicants[i], function(value, key) {
                        if ((parent.$.applicants[i]['x'+key]!==undefined) && (parent.$.applicants[i]['x'+key]==null)) {
                            parent.$.applicants[i]['x'+key] = parent.getField(parent.$.applicants[i], key); 
                        }
                    });
                } 
            }

            //A

            //B
            this.$.status = {isopen: false};
            this.$.status = {isopen2: false};
        }

        this.$.SliderService = this.SliderService;
        this.$.SliderFactory = this.SliderFactory;



        if (typeof this.ApplicationService.getApplicationID() !== 'undefined' && !this.ApplicationService.getLoadingApplication())
        {
            //Child + Dep Count fam 1 B
            this.$.dcCount = [];
            this.$.dcCount[0] = this.ApplicationService.getAwardData().family[0].children.length +
            this.ApplicationService.getAwardData().family[0].dependant.length;
            if (this.ApplicationService.getAwardData().family.length > 1)
            {
                this.$.dcCount[1] = this.ApplicationService.getAwardData().family[1].children.length +
                this.ApplicationService.getAwardData().family[1].dependant.length;
            }


            if (this.ApplicationService.getAwardData().app[0].Status_New == 1)
                this.$.bin = "Status_New";
            else if (this.ApplicationService.getAwardData().app[0].Status_Viewed == 1)
                this.$.bin = "Status_Viewed";
            else if (this.ApplicationService.getAwardData().app[0].Status_Consider == 1)
                this.$.bin = "Status_Consider";
            else if (this.ApplicationService.getAwardData().app[0].Status_Award == 1)
                this.$.bin = "Status_Award";
            else (this.ApplicationService.getAwardData().app[0].Status_Reject == 1)
                this.$.bin = "Status_Reject";
        }
    },
    calcAge: function(dob) {
        if (dob) {
            let year = dob.toString().substr(0,4);
            let month = dob.toString().substr(4,2);
            let day = dob.toString().substr(6,8);
            let birth = moment(year + "-" + month + "-" + day);
            let now = moment();
            return now.diff(birth, "years");
        }
    },
    openPerson: function(type, index)
    {
        if (type=='Family 1')
            this.SliderService.pushSlider(new this.SliderFactory('applicationSidebar/partials/parentInfo', 'Family 1 Parents', 'm', {'tab':index}))
        else if (type=='Family 2')
            this.SliderService.pushSlider(new this.SliderFactory('applicationSidebar/partials/parentInfo', 'Family 2 Parents', 'm', {'tab':index}))
        else if (type=='Children')
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardData/partials/awardDataDepChilds', 'Children & Dependents', 'm', {type:'c','tab':index}))
        else if (type=='Dependents')
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardData/partials/awardDataDepChilds', 'Children & Dependents', 'm', {type:'d','tab':index}))
        else if (type=='Applicants')
            this.SliderService.pushSlider(new this.SliderFactory('applicationSidebar/partials/applicantInfo', 'Applicants', 'm', {'tab':index}))
    },
    isDeleted: function(divcode)
    {
        this.items = this.GradeSetupModelService.get();
        for (var i = 0; i < this.items.length; i++) {
            if (divcode==this.items[i].DivisionCode) {
                if (this.items[i].del==1) {
                    this.$.showmessage=1;
                    return true
                }
                else {
                    this.$.showmessage=0;
                    return false
                }
            }
        }
        this.$.showmessage=1;
        return true;
    },
    formatMonth: function(str)
    {
        //str = toString();
        var year = str.substr(0, 4);
        var month = str.substr(4, 2);
        var day = str.substr(6, 2);
        return month + '/' + day + '/' + year;
    },
    toggleDropdown: function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        this.$.status.isopen = !this.$.status.isopen;
    },
    stopIt: function($event)
    {
        $event.stopPropagation();
    },
    appPut: function()
    {
        var app = this.ApplicationService.getAwardData().app[0]
        this.AppModelService.put(app.applicationID, app);
    },
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    },
    familyClick: function(index, div)
    {
        var parent = this;
        this.ApplicationService.setFamilyNo(index)
        this.MainContentService.setActiveDiv("applicationOverview");
        parent.TabsService.setActiveTab("awardData");

    },
    awardData: function(index, div)
    {
        var parent = this;
        this.ApplicationService.setFamilyNo(index)
        //this.MainContentService.setActiveDiv("tabs");
        parent.TabsService.setActiveTab("awardData");
    },
    hasAlertsClass: function()
    {
        for (var key in this.AlertService.getAlerts()) {
            if (this.AlertService.getAlerts()[key].text !== "Add Allowances" && this.AlertService.getAlerts()[key].text !== "Adjust Income")
                var ballClass = this.$.getBallClass(key);
                if (ballClass == "text-warning" || ballClass == "text-danger")
                    return "text-warning";
        }
        return "text-success";
    },
    getBallClass: function(alertName)
    {
        var alert = this.AlertService.getAlerts()[alertName];
        if (alert.fired == true && alert.complete == 1)
            return 'text-' + alert.stateType;
        else
        {
            if (alert.state == "disabled" || alert.state == "void")
                return 'text-success';
            return 'text-' + alert.state;
        }
    },
    jumpToTaxes: function(index)
    {
        if (this.authServiceFactory.getAuth().permissions.taxTab==1) {
            this.familyClick(index);
            this.TabsService.setActiveTab('taxes');
        }
    }
});

applicationSidebar.service('ApplicationSideBarService', function (ApplicationService, AppModelService, BinFactory, $rootScope) {
    var opened, pulsate;

    var initOpened = function()
    {
        if (typeof opened === 'undefined')
        {
            opened = Array();
            opened[0] = Array(); //Applications
            opened[1] = Array(); //Family 1
            opened[2] = Array(); //Family 2

            opened[0][0] = false;
            opened[0][1] = false;
            opened[0][2] = false;
            opened[0][3] = false;
            opened[0][4] = false;
            opened[0][5] = false;
            opened[0][6] = false;

            opened[1][0] = false;
            opened[1][1] = false;

            opened[2][0] = false;
            opened[2][1] = false;
        }
    }

    var initPulsate = function()
    {
        if (typeof pulsate === 'undefined')
        {
            pulsate = Array();
            pulsate[0] = Array(); //Applications
            pulsate[1] = Array(); //Family 1
            pulsate[2] = Array(); //Family 2

            pulsate[0][0] = false;
            pulsate[0][1] = false;
            pulsate[0][2] = false;
            pulsate[0][3] = false;
            pulsate[0][4] = false;
            pulsate[0][5] = false;
            pulsate[0][6] = false;

            pulsate[1][0] = false;
            pulsate[1][1] = false;

            pulsate[2][0] = false;
            pulsate[2][1] = false;
        }
    }

    return {
        togglePulsate: function(section, index)
        {
            initPulsate();
            pulsate[section][index] = !pulsate[section][index];
        },
        toggleOpen: function(section, index)
        {
            initOpened();
            opened[section][index] = !opened[section][index];
        },
        toggleOpenPulsate: function(section, index)
        {
            initOpened();
            opened[section][index] = !opened[section][index];
            initPulsate();
            pulsate[section][index] = !pulsate[section][index];
        },

        getOpened: function(section, index)
        {
            initOpened();
            return opened[section][index];
        },
        getPulsate: function(section, index)
        {
            initPulsate();
            return pulsate[section][index];
        },
        setBin: function(bin)
        {
            var parent = this;
            ApplicationService.getAwardData().app[0].Status_New = 0;
            ApplicationService.getAwardData().app[0].Status_Viewed = 0;
            ApplicationService.getAwardData().app[0].Status_Consider = 0;
            ApplicationService.getAwardData().app[0].Status_Award = 0;
            ApplicationService.getAwardData().app[0].Status_Reject = 0;
            ApplicationService.getAwardData().app[0].Status_Unfinished = 0;
            ApplicationService.getAwardData().app[0][bin] = 1;



            var data = {
                'Status_New': ApplicationService.getAwardData().app[0].Status_New,
                'Status_Viewed': ApplicationService.getAwardData().app[0].Status_Viewed,
                'Status_Consider': ApplicationService.getAwardData().app[0].Status_Consider,
                'Status_Award': ApplicationService.getAwardData().app[0].Status_Award,
                'Status_Reject': ApplicationService.getAwardData().app[0].Status_Reject,
                'Status_Unfinished': ApplicationService.getAwardData().app[0].Status_Unfinished
            };
            AppModelService.put(ApplicationService.getApplicationID(), data).then(function()
            {
                BinFactory.currentBinAppRef.Status_New = ApplicationService.getAwardData().app[0].Status_New;
                BinFactory.currentBinAppRef.Status_Viewed = ApplicationService.getAwardData().app[0].Status_Viewed;
                BinFactory.currentBinAppRef.Status_Consider = ApplicationService.getAwardData().app[0].Status_Consider;
                BinFactory.currentBinAppRef.Status_Award = ApplicationService.getAwardData().app[0].Status_Award;
                BinFactory.currentBinAppRef.Status_Reject = ApplicationService.getAwardData().app[0].Status_Reject;
                BinFactory.currentBinAppRef.Status_Unfinished = ApplicationService.getAwardData().app[0].Status_Unfinished;
                BinFactory.getBinCount();
                $rootScope.$broadcast('SubNavApplicationBin');

            });
        }
        /*
       expand: function($event)
        {
            var tParent = $($event.target).parent().parent();
            if ( tParent.hasClass("open"))
                tParent.removeClass("open")
            else
                $($event.target).parent().parent().addClass("open");
        }*/
    };
});
/* End applicationSidebar Module */